import { createStyles } from '@material-ui/core';
import type { Theme } from '@material-ui/core';

import colours from '../../../styles/colours';

const styles = (theme: Theme) => {
  return createStyles({
    base: {
      backgroundColor: colours.lightBlue700,
      color: 'white',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: colours.lightBlue
      }
    },
    flat: {
      backgroundColor: 'none',
      color: theme.color,
      boxShadow: 'none',
      fontWeight: 'bold'
    },
    small: {
      minWidth: 'auto',
      height: 24,
      minHeight: 24,
      padding: '5px 16px',
      fontSize: '12px',
      lineHeight: '12px'
    },
    errored: {
      backgroundColor: colours.red200,
      color: colours.red
    },
    warning: {
      backgroundColor: colours.orange200,
      color: colours.orange
    },
    disabled: {
      backgroundColor: colours.grey50,
      border: '1px dotted',
      borderColor: colours.grey100,
      pointerEvents: 'none',
      cursor: 'disabled'
    },
    outlineMode: {
      backgroundColor: 'transparent',
      border: '1px solid white'
    },
    iconButton: {
      minWidth: 24
    }
  });
};

export default styles;
